module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre4",
    attrs: {
      "id": "pgepubid00016"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page3"
    }
  }), _c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "pgepubid00017",
      "title": "p. 3"
    }
  }), _vm._v("CHAPTER I."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall"
  }, [_vm._v("THE WEST BOW BALL.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("The")]), _vm._v(" last of the West Bow balls before Lady Charlotte ran away with her dancing-master was on a dirty evening in November. Edinburgh was all day wrapped in haar, and now came rain that made the gutters run like mountain burns and overflow into the closes, to fall in shallow cataracts to the plain below. There was a lively trade in the taverns. “Lord! there’s a sneezer for ye!” said the customers ordering in their ale, not really minding the weather much, for it was usual and gave a good excuse for more assiduous scourging of the nine-gallon tree; "), _c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00018",
      "title": "p. 4"
    }
  }), _vm._v("but their wives, spanging awkwardly on pattens through the mud on their way to the fishwife at the Luckenbooths for the supper haddocks, had such a breeze in their petticoats and plaids they were in a terror that they should be blown away upon the blasts that came up the gulleys between the towering “lands,” and daring slates and chimney-pots, and the hazards of emptied vessels from the flats above, kept close to the wall as luggers scrape the shore of Fife when the gale’s nor’-west.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Lady Charlotte was director of the dance—a creature most majestic, who ballooned about the room as if not her feet but her big hooped petticoat conveyed her, the only woman without a mask; that in her office would be useless. All the other women kept theirs on, with silken cords bit between the teeth (except when a favourite partner caused a titter). Below the velvet, when it tilted up, they showed the cheeks of youth and beauty, sometimes a little high in the "), _c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00019",
      "title": "p. 5"
    }
  }), _vm._v("bone for classic taste, and a patch on the chin just at the point where to a resolute lad it looked like a defiance. The flute, the hautbois, and the ’cello gave body to the melody of the harpsichord, somewhat flat the whole of them, for the place was sweltering, and the stuccoed ceiling sweated, and the walls.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("A gentleman, conspicuous from the fact that he wore no wig, stood in the dusk at the foot of the room, away from the guttering candelabra, and put up his hand to hide a yawn. The minuet was beyond him, and seemed to him who came from the wilds, where the languid had no place in merriment, a somewhat insipid affair. In the card-room, where old dowagers played cards till their girls should be ready to go home, and the young ones sat with their chosen gallants, sipping tea in the latest manner, he had ventured a harmless remark to a lady neither too young nor too lovely to resent a politeness at a masque assembly, and she "), _c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00020",
      "title": "p. 6"
    }
  }), _vm._v("had fled to her friends as if he were an ogre.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("He was neither surprised nor vexed; he was accustomed to have the fair avoid him, though scarcely with such obvious fastidiousness as to-night. It was one of the things to be expected by a man with a crooked nose and the plainness of his other features in conformity with that one, even if he had not happened to be there incognito.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“To the devil!” said he to himself. “I cannot expect them to be civil to any casual Jo at a two-and-sixpenny ball.” And he yawned again, impatient for the coming away of his cousin, whose gallantries to a lady at the other end of the room seemed unending. From that cousin he neither expected the ordinary courtesies of life nor desired them. They were usually as cool to each other as if they had sprung from different clans, and it was only the accident of a law plea affecting the family in its various branches that brought them privately "), _c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00021",
      "title": "p. 7"
    }
  }), _vm._v("to the capital and to the same lodgings from widely different parts of their native shire, and from widely different ways of life.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Whatever the cousin had to say to madam, she was pretty merry on the head of it, and seemed entranced with her gallant. He was such a coxcomb surely as never before came off the heather, with his Genoa velvet coat, his sky-blue breeches, and a waistcoat of the tartan of his clan, a thin, delicate, lady-like sword at his haunch that better knew the swing of the claymore.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“A rogue, Jock! and a tongue to wile the bird off the tree,” thought the man with the crooked nose, in no envy at all, but just in a distaste at nature’s perversity; and he saw that his cousin and the lady looked at him as if he were the object of their conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("To his astonishment, the lady, at the forming of the next quadrille, was brought to him by Lady Charlotte. “You see, if the mountain ’ll not come to Mahomet, "), _c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00022",
      "title": "p. 8"
    }
  }), _vm._v("Mahomet maun just come to the mountain,” said the directress airily. “Here’s a leddy I’m determined shall not miss her quadrille, and you are very lucky, Mr—Mr—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Macdonald,” said he, with a bow and a glance of shrewdness at the young lady, who had plainly made the arrangements herself for the introduction.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Mr Macdonald—just so! a rale decent clan,” said Lady Charlotte, who prided herself upon the quality of her Scots. “I mind you had the tickets from Lord Duthie; you’re lucky to have the chance of the bonniest partner in the room.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I’ll take your word for it,” said he, with another glance at a very soothfast mask that came down on as sweet a pair of lips as ever man took craving for.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("At a quadrille he was not amiss if one could get over the crook in his nose and the rugged plainness of his countenance generally. When he was done and brought the lady to a seat, she was good enough to say "), _c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00023",
      "title": "p. 9"
    }
  }), _vm._v("he danced divinely. She had herself the carriage of a swan, her voice was of a ravishing and caressing quality, with none of the harsh, high-pitched, East-country accent that would have grated on Macdonald’s ears, and yet there was a something shallow in her phrase and sentiment.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“You are very good to say so, ma’am. I rarely dance, and I have seldom danced less at an assembly than I have done to-night,” said he, taking the compliment at its real value, for his dancing was a point on which he had no illusions.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("The lady toyed with her fan; her eyes, mischievous and profound as wells and of the hue of plums, sparkled through the holes in her mask.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Oh la! and you divine at it, I declare! Our Edinburgh belles, then, do not tempt you, Mr Macdonald? But I daresay you will think them quite good enough for our Edinburgh beaux; now, did you ever in your life see such gawks?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00024",
      "title": "p. 10"
    }
  }), _vm._v("Macdonald rubbed his chin. “On the contrary,” said he, “I was just thinking them uncommon spruce and handsome.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“You are very tolerant; have you any other virtues to be aired?” said the lady with a smile that puzzled him. “There’s still another dance, I see; her ladyship is fairly in the key to-night; you’ll have time to tell me all of them seriatim, missing out the lesser ones "), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("brevitatis causa")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“H’m!” thought he; “her father’s in the law,” and wondered who she was. “I could tell you all of them in the time it would take to dance a step of the Highland Fling,” said he.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Faith, there’s modesty! Item, Mr Macdonald?” and she sat back in her chair, her hoops bulged out in front of her like the bastion of a fort.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("He counted them on his fingers humorously. “Item, the tolerance you have given me credit for, though you have no example of it as yet, madam; item, an honest liking "), _c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00025",
      "title": "p. 11"
    }
  }), _vm._v("for my fellows, even the scamps of them; item, a habit of aye paying my way; item—” his forefinger hovered dubiously over the other hand, but never lighted on another virtue. “I declare to you I have got to the end of my list and the man has not yet finished the tuning of his fiddle,” he said, laughing in a way so pleasant it almost made amends for his unhappy nose.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("He had taken a seat beside her, she tapped him with her fan upon the knees with an air of the superior that struck him as a little droll, and, looking straight in his face, said in an affected Scots, as if to take the sting from the words: “A’ very fine, Maister Macdonald, a’ very fine! What have ye given me here but twa-three virtues that come—except maybe the last—so easy to maist folk they’re nae mair to your credit than that you should sup kail wi’ a spoon?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“A poor show, I confess it, ma’am; if you want a list of more brilliant virtues, "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00026",
      "title": "p. 12"
    }
  }), _vm._v("you should try my worthy cousin, your last partner,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Do you tell me that—Barrisdale?” said the lady, burring her “r’s” with a gusto to make him certain she had no dubiety regarding his identity.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("He could not hide a little start of surprise, for he thought the secret of his cousin and himself being in Edinburgh was known to but two men there, Lord Duthie and Mackee.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“You’re the daughter of Lord Duthie,” said he, remembering her law Latinity.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("She was confused at so shrewd a guess, but admitted he was right. “It has long been my wish,” said she, “to have a crack with a Highland rob—, with a Highland person of your experience; and I must confess I asked Lady Charlotte for the introduction, though you may not think it modest. Let me tell you that I’m disappointed; it ill becomes a gentleman of Barrisdale’s reputation to be claiming such "), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00027",
      "title": "p. 13"
    }
  }), _vm._v("paltry common virtues as those you have named to charm the ear of an unknown lady in a mask. They credit ye with Latin and French, and say ye cut a dash whiles in London—oh la! a wonnerfu’ man entirely!—but upon my word, I never thought to get a catechist in my Hielan cateran.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Here’s a comedy,” thought he, looking across the room to his cousin. “How in the world did you discover me?” he asked her; “did my cousin—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“He did,” said she, “and he told me not to mention it; but you see, I take the privilege of my sex.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I cannot but be flattered at your interest, ma’am, I’m sure, and I hope you will not let the thing go further so long as I’m in Edinburgh. Now that I’m discovered, I’m wae to be back to my ruffian gang,” said he, with a quizzing air. “I must have a most tremendous reputation, and I would not wonder if you could go over all my history.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00028",
      "title": "p. 14"
    }
  }), _vm._v("“I daresay I know the worst of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Do you? Faith! it’s more than I do myself; might I ask you to be jogging my memory?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“When I come to think of it,” said she, “the very virtues that you claim are what in the rough bounds of the Hielans may well manifest themselves in fashions that hereabouts in lalland towns we clap men into jyle for.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Indeed, I should not wonder, ma’am,” said he; “what’s counted a crime in one parish, even in the Hielans, is often looked on as a Christian act in others not a glen removed.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“You talk of tolerance, Barrisdale; was it that made you hide in Ben Alder for a twelvemonth the man that shot Breadalbane’s factor?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“He was a very old man, the factor, Miss Duthie,” said he glibly. “He would have died in another winter, anyway, by all appearances, and not half so handsomely "), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00029",
      "title": "p. 15"
    }
  }), _vm._v("as with a bullet. And the poor fellow who shot him—you would not have us send a man with a wife and ten of a family to the gallows?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Lord!” cried the lady, affecting to be out of patience. “You are a rebel too, my father tells me, and all for having back those Papist Stuarts and putting the dear King away out of the country. Is that a sample of your love for your fellowmen?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Logic,” thought Macdonald, “is not a branch that’s taught with the virginals and tambouring in lawyers’ families.” “Well, ma’am,” said he, “could you blame me? I have been in France a while myself, and I ken the kind of drink they have to drink there; I would not poison dogs with it. I would have Jamie back for no other reason than to save what relics of his stomach may be to the fore. What’s that but love for my fellows?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Was it that made you fight with the "), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00030",
      "title": "p. 16"
    }
  }), _vm._v("London gentleman and send him—poor soul—to his Maker at five o’clock on a cold winter morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“It’s a small world. Who would have thought the gossip of that trivial affair would have travelled to an Edinburgh assembly? Sure you would not have had me put off the occasion till the summer weather; we were both warm enough at the time, I assure you, or that black folly they call a duel had never been engaged in.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“You have the name of—of—I hate to mention it,” said the lady, now grown eager and biting her under lip.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Oh, out with it! out with it! Crown Counsel should never be blate, ma’am; on my word, the talent for cross-examination would seem to run in the family.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Blackmail and—” said she in a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“One at a time!” said Macdonald. “That’s the prose way of putting it; up north we put "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00031",
      "title": "p. 17"
    }
  }), _vm._v("it differently. You call it robbery; we call it rent. Some charge the rent by the pennyland or the acre; we charge it by the sound night’s sleep, and the man who rents immunity from his cattle from Barrisdale gets as good value for his money as the man who rents some acres of dirt from Appin.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Madam worked her fan industriously—now she was on his heels, and could not spare so plain a mercenary. “You steal cattle,” was her next charge.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Steal! ma’am,” said Barrisdale, with a frown. “It is not the bonniest word; up north we call it "), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("togail")]), _vm._v("—lifting. It is an odd world, mistress, and every man of us has to do some sort of lifting for a living—if not in the glen, then in the market-place, where the act is covered in a fine confusion. If we lift a "), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("creach")]), _vm._v(" now and then in Barrisdale there are other clans that lift from us, and at the season’s end no one is much the worse, and there has been much frolic and diversion.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00032",
      "title": "p. 18"
    }
  }), _vm._v("“On the same reasoning, then, you would justify the attempt at abducting Glen Nant’s rich daughter?” said the lady.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Do you happen to have seen her?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I have,” said the lady, and could not for her life have kept from smiling. “It was the sight of her spoiled what small romantics I had about the Hielan cateran.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Are you sure there are none to the fore yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Not a morsel!” said the lady, looking point-blank at his nose.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“"), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("Mo thruagh")]), _vm._v("!” said Macdonald tragically; “then are we indeed forsaken.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“You made a shabby flight, by all accounts, from the lady’s brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Humph!” said he, for the first time disconcerted; indeed, it was a story no way creditable to Clan Macdonald. “I think,” said he, “we’ll better let that flea stick to the wall,” and looked across the room to where his cousin sat glowering in a manifest anxiety.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00033",
      "title": "p. 19"
    }
  }), _vm._v("“Oh, Barrisdale, Barrisdale, can ye no’ be a good man?” said Miss Duthie, in a petty lady-like concern, and unable to keep her eyes from that unlucky nose.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("He put up his hand and covered it. She flushed to the neck that he should so easily have divined her, and he laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“It’s no use trying, ma’am,” said he. “Let me be as good as gold and I would never get credit for it from your sex, that must always fancy that a handsome face never goes but with a handsome heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("She rose with an air of vexation to leave him, very red below her mask; the last dance was on the point of ending, the dowagers were coming in with their Paisley plaids on their shoulders. “I would never hurt any person’s feelings by allusion to his personal appearance,” she said, as she was turning away.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I am sure of it, ma’am,” said he; “you are most considerate.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0